export const getProductNameFromShorthand = (shorthand: string | null) => {
  switch (shorthand?.toLowerCase()) {
    case 'pdl':
      return 'PDL';
    case 'gdl':
      return 'GDL';
    case 'analytics':
      return 'Analytics';
    case 'recruit':
      return 'Recruit';
    case 'payroll':
      return 'Payroll';
    case 'finance':
      return 'Finance';
    case 'connect':
      return 'Connect';
    case 'work-app':
      return 'Work App';
    case 'hub':
      return 'Hub';
    case 'cockpit':
      return 'Cockpit';
    case 'aueoffice':
      return 'AÜOffice';
    case 'it':
      return 'IT';
    case 'leviy':
      return 'LeviyApp';
    default:
      return $localize`:@@product.unknown:Unbekanntes Produkt`;
  }
};
